// extracted by mini-css-extract-plugin
module.exports = {"catList":"blogImage_catList___vPoq","links":"blogImage_links__i2BXg"};